import {usePortalTooltip} from '@github-ui/portal-tooltip/use-portal-tooltip'
import {CopilotIcon} from '@primer/octicons-react'
import {ButtonGroup, IconButton} from '@primer/react'
import clsx from 'clsx'
import type {ComponentProps} from 'react'
import {useRef} from 'react'
import styles from './styles.module.css'

export interface BaseCopilotChatButtonProps
  extends Omit<ComponentProps<typeof IconButton>, 'icon' | 'aria-label' | 'aria-labelledby'> {
  referenceType: string
  children?: JSX.Element
  containerClassName?: string
}

export function BaseCopilotChatButton({
  children,
  containerClassName = 'pr-3',
  referenceType,
  ...props
}: BaseCopilotChatButtonProps) {
  const contentRef = useRef<HTMLButtonElement>(null)

  const label = `Ask Copilot about this ${referenceType}`

  const [attrs, portalElement] = usePortalTooltip({
    'aria-label': label,
    contentRef,
    direction: 'sw',
    anchorSide: 'outside-bottom',
  })

  return (
    <ButtonGroup className={containerClassName}>
      <IconButton
        className={clsx(styles['square'], !!children && styles['muted'])}
        ref={contentRef}
        icon={CopilotIcon}
        size="small"
        aria-label={label}
        data-testid="copilot-ask-menu"
        {...attrs}
        {...props}
      />
      {children}
      {portalElement}
    </ButtonGroup>
  )
}

try{ BaseCopilotChatButton.displayName ||= 'BaseCopilotChatButton' } catch {}